import { cn } from "@/lib/utils";

const STYLES = {
  online: { label: "Online", dot: "bg-[hsl(var(--ok))]", text: "text-[hsl(var(--ok))]", bg: "bg-[hsl(var(--ok)/0.1)]", pulse: true },
  syncing: { label: "Exporting", dot: "bg-[hsl(var(--warn))]", text: "text-[hsl(var(--warn))]", bg: "bg-[hsl(var(--warn)/0.12)]", pulse: true },
  paused: { label: "Paused", dot: "bg-[hsl(var(--warn))]", text: "text-[hsl(var(--warn))]", bg: "bg-[hsl(var(--warn)/0.12)]" },
  offline: { label: "Offline", dot: "bg-muted-foreground", text: "text-muted-foreground", bg: "bg-muted" },
  pending: { label: "Waiting for first contact", dot: "bg-muted-foreground", text: "text-muted-foreground", bg: "bg-muted" },
  error: { label: "Error", dot: "bg-[hsl(var(--bad))]", text: "text-[hsl(var(--bad))]", bg: "bg-[hsl(var(--bad)/0.1)]" },
  revoked: { label: "Key revoked", dot: "bg-[hsl(var(--bad))]", text: "text-[hsl(var(--bad))]", bg: "bg-[hsl(var(--bad)/0.1)]" },
  done: { label: "Done", dot: "bg-[hsl(var(--ok))]", text: "text-[hsl(var(--ok))]", bg: "bg-[hsl(var(--ok)/0.1)]" },
  exporting: { label: "Exporting", dot: "bg-[hsl(var(--warn))]", text: "text-[hsl(var(--warn))]", bg: "bg-[hsl(var(--warn)/0.12)]", pulse: true },
};

export function StatusBadge({ status, label, testId = "status-badge", className }) {
  const s = STYLES[status] || STYLES.offline;
  return (
    <span data-testid={testId} className={cn("inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 text-xs font-medium whitespace-nowrap", s.bg, s.text, className)}>
      <span className="relative flex h-1.5 w-1.5">
        {s.pulse && <span className={cn("absolute inline-flex h-full w-full animate-ping rounded-full opacity-60", s.dot)} />}
        <span className={cn("relative inline-flex h-1.5 w-1.5 rounded-full", s.dot)} />
      </span>
      {label || s.label}
    </span>
  );
}

export function Stat({ label, value, sub, testId }) {
  return (
    <div className="surface p-5" data-testid={testId}>
      <div className="eyebrow">{label}</div>
      <div className="mt-2 text-2xl font-semibold tracking-tight num">{value}</div>
      {sub && <div className="mt-1 text-xs text-muted-foreground">{sub}</div>}
    </div>
  );
}

export function PageHeader({ title, subtitle, children }) {
  return (
    <div className="mb-8 flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
      <div>
        <h1 className="text-3xl font-semibold tracking-tight sm:text-4xl">{title}</h1>
        {subtitle && <p className="mt-2 max-w-2xl text-sm text-muted-foreground sm:text-base">{subtitle}</p>}
      </div>
      {children && <div className="flex flex-wrap gap-2">{children}</div>}
    </div>
  );
}

export function EmptyState({ icon: Icon, title, text, children, testId }) {
  return (
    <div className="surface flex flex-col items-center px-6 py-14 text-center" data-testid={testId}>
      {Icon && <div className="mb-4 rounded-2xl bg-secondary p-3"><Icon className="h-6 w-6 text-muted-foreground" /></div>}
      <div className="text-base font-semibold">{title}</div>
      {text && <p className="mt-1 max-w-md text-sm text-muted-foreground">{text}</p>}
      {children && <div className="mt-5">{children}</div>}
    </div>
  );
}
